import { Component, OnInit } from '@angular/core';
import { RoomsModel } from 'src/app/models/RoomsModel';
import { RoomsService } from '../../services/RoomsService';
import { LocalStorageService } from 'ngx-webstorage';
import { RoomssearchComponent } from '../roomssearch/roomssearch.component';
import {formatDate} from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rooms',
  templateUrl: './rooms.component.html',
  styleUrls: ['./rooms.component.css'],
})
export class RoomsComponent implements OnInit {
  roomCode = '';
  roomName = '';
  roomType = '';
  roomNotes = '';
  compCode = '1';
  userID = '';
  modifiedDate = '2021-01-01';

  constructor(public RoomsService: RoomsService,
              public rooms: RoomsModel,
              private dialogref: MatDialog,
              public storage: LocalStorageService,
              public roomsSelectedData: RoomsModel) {}

  ngOnInit(): void {}

  retriveRooms() {
    this.RoomsService.getRooms(this.roomCode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: RoomsModel) => {

        this.roomName = data.roomName;
        this.roomType = data.roomType;
        this.roomNotes = data.roomNotes;

        this.userID = data.userID;
        this.modifiedDate = data.modifiedDate;
        this.compCode = data.compCode;
        console.log(data);
      }
    );
  }
  DeleteRooms() {
    this.RoomsService.delRooms(this.roomCode, this.compCode).subscribe(
      (data: RoomsModel) => {
        this.roomCode = data.roomCode;
        this.roomName = data.roomName;
        this.roomType = data.roomType;
        this.roomNotes = data.roomNotes;
        this.compCode = data.compCode;
        this.userID = data.userID;
        this.modifiedDate = data.modifiedDate;
        console.log(data);
      }
    );
  }
  NewData() {
    this.roomCode = '';
    this.roomName = '';
    this.roomType = '';
    this.roomNotes = '';
    this.userID = 'sa';
    this.modifiedDate = '2021-01-01';
    this.compCode = '1';
  }

  submitRooms() {
    this.rooms.roomCode = this.roomCode;
    this.rooms.roomName = this.roomName;
    this.rooms.roomType = this.roomType;
    this.rooms.roomNotes = this.roomNotes;

    this.rooms.userID = this.storage.retrieve('stguserId');
    this.rooms.modifiedDate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.rooms.compCode = this.storage.retrieve('stgcompCode');

    this.RoomsService.AddRooms(this.rooms).subscribe(
      (data) => {
        console.log(data.roomCode);
        this.mesgSave();
        this.NewData();
      },
      (error) => {
        alert(error);
      }
    );
  }
  mesgDelete() {
    console.log('in msg delete');
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.DeleteRooms();
        Swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  openDialog(){
    const dialogRef = this.dialogref.open(RoomssearchComponent,
      {
        data: {
          dataKey: this.roomsSelectedData
        },
        width: '80%'
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.roomCode = result.roomCode;
        this.retriveRooms();
        dialogSubmitSubscription.unsubscribe();
      });

  }
  mesgSave() {
    Swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }
}

